import { render, staticRenderFns } from "./clue.vue?vue&type=template&id=ecdd8422&scoped=true&"
import script from "./clue.vue?vue&type=script&lang=js&"
export * from "./clue.vue?vue&type=script&lang=js&"
import style0 from "./clue.vue?vue&type=style&index=0&id=ecdd8422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdd8422",
  null
  
)

export default component.exports